<template>
  <AppView class="contest-game">
    <TheGame @end="onGameEnd($event)" />
  </AppView>
</template>

<script>
import AppView from '@/components/AppView.vue';
import TheGame from '@/components/TheGame.vue';
import { SET_ANSWER, SET_ATTACHMENT, SET_SCORE } from '@/store.js';

export default {
  name: 'ContestGame',
  components: {
    AppView,
    TheGame,
  },
  methods: {
    onGameEnd({ answer, attachment, score }) {
      this.$store.commit(SET_ANSWER, { answer });
      this.$store.commit(SET_ATTACHMENT, { attachment });
      this.$store.commit(SET_SCORE , { score });

      this.$router.push('/contest/form');
    },
  },
};
</script>

<style lang="scss">
.contest-game {}
</style>
